import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryCard.css';

// Category icons mapping
const categoryIcons = {
  'Creative and artistic': 'https://img.icons8.com/?size=96&id=Xwqu8cUREfko&format=png',
  'Performing arts': 'https://img.icons8.com/?size=96&id=36791&format=png',
  'Sports and physical activity': 'https://img.icons8.com/?size=96&id=SMjRXXIK5MOb&format=png',
  'Culinary activity': 'https://img.icons8.com/?size=96&id=BeDidZchwnxG&format=png',
  'Games and puzzles': 'https://img.icons8.com/?size=96&id=16426&format=png',
  'Outdoor and nature based activity': 'https://img.icons8.com/?size=96&id=R1DoeL1vKksj&format=png',
  'Collecting hobbies': 'https://img.icons8.com/?size=96&id=18053&format=png',
  'Intellectual and learning': 'https://img.icons8.com/?size=96&id=vo1XcGH8QAag&format=png',
  'Other': 'https://img.icons8.com/?size=96&id=0Z2th4OTrTEb&format=png'
};

// Get total events count from serviceStats
const getTotalEvents = (serviceStats) => {
  if (!serviceStats || !Array.isArray(serviceStats)) return 0;
  return serviceStats.reduce((sum, count) => sum + count, 0);
};

export const CategoryCard = ({ category, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(category._id);
    } else {
      navigate(`/listing/${category._id}`);
    }
  };

  return (
    <div className="category-card-pill" onClick={handleClick}>
      <div className="category-icon">
        <img src={categoryIcons[category.service_name] || '🎯'} alt="" />
        
      </div>
      <div className="category-info">
        <h3 className="category-name">{category.service_name}</h3>
        <div className="category-stats">
         
          <span className="stat-item">
           View all Events
          </span>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
